import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { CircleLoader } from "react-spinners";

const Blacklist = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [blacklist, setBlacklist] = useState();
    const [search, setSearch] = useState('');
    const [searchFilter, setFilter] = useState('company')

    const [representatives, setRepresentatives] = useState([])
    const [fullBlacklist, setFullBlacklist] = useState([]);



    const test_link = "http://localhost:3000/"
    const production_link = "https://apple-tree-server.vercel.app/"


    const getRepresentatives = async () => {
        await axios.get(production_link +'representatives/')
        .then(response => {
            setRepresentatives(response.data)
        })

    }

    const filterBlacklist = (data) => {
        const filteredData = data.filter(item => {
            if (searchFilter === 'company') {
                return item.company_name?.toLowerCase().includes(search.toLowerCase());
            } else if (searchFilter === 'user listed') {
                return (item.user_first_name + ' ' + item.user_last_name)?.toLowerCase().includes(search.toLowerCase());
            } else if (searchFilter === 'representative') {
                for (let rep of representatives) {
                    if (item.company_id === rep.company_id) {
                        if ((rep.first_name + ' ' + rep.last_name)?.toLowerCase().includes(search.toLowerCase())) {
                            return true;
                        }
                    }
                }
            } else if (searchFilter === 'category') {
                return item.category?.toLowerCase().includes(search.toLowerCase());
            } else if (searchFilter === 'id') {
                for (let rep of representatives) {
                    if (item.company_id === rep.company_id) {
                        if (rep.id_number?.includes(search)) {
                            return true;
                        }
                    }
                }
            } else if (searchFilter === 'company reg') {
                return item.registration_number?.includes(search);
            }
            return false;
        });
    
        setBlacklist(filteredData);
    };
    

    const getBlacklist = async () => {
        await axios.get(production_link + 'blacklist/')
            .then(response => {
                setFullBlacklist(response.data.reverse());  // Store the full data
                filterBlacklist(response.data);   // Filter it for initial render
            });
    };
    

    useEffect(() => {
        setIsVisible(true);
        getBlacklist()
        getRepresentatives()
    }, []);

    useEffect(() => {
        if (fullBlacklist != null) {
           filterBlacklist(fullBlacklist); 
        }
         // Filter the already fetched data
    }, [search, searchFilter]);
    

    const navigate = useNavigate();

    if (blacklist == null) {
        return (
            <div>
            <h4 className="text-center display-5 fst-italic text-muted">Blacklist</h4>
                 
                <div style={{height:"50vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
            </div>
            
        )
    }

    return ( 
        <div>
            <h4 className="text-center display-5 fst-italic text-muted">Blacklist</h4>
            <div className="d-flex justify-content-center m-4">
                <div className="btn-group w-75">
                    <select name="filter" id="" className="form-select w-25 rounded-0 rounded-start" onChange={(e) => {
                        setFilter(e.target.value)
                        }}>
                            <option value="company">Company</option>
                            <option value="user listed">Listed by</option>
                            <option value="representative">Representative</option>
                            <option value="category">Category</option>
                            <option value="id">ID number</option>
                            <option value="company reg">Company registration number</option>
                    </select>
                    <input type="text" className="form-control w-75 rounded-0 rounded-end" placeholder={`Search by ${searchFilter}`} onChange={(e) => {
                        setSearch(e.target.value);
                    }}></input>
                </div>
                
            </div>
            <div className="d-flex flex-column justify-content-center">
                <div className="container w-75">
                    <p className="text-muted text-end blockquote-footer">{blacklist.length} results</p>
                </div>
               {
                blacklist.map((item) => {
                    if (item.archived == "false") {
                        let blacklist_date = item.blacklist_date;
                    const new_date = moment(blacklist_date).format('Do MMM YYYY')
                    return (
                        <div className={`container notification w-75 py-3 my-3 ${isVisible ? 'fade-in-left' : ''}`} onClick={() => {
                            navigate(`/blacklist/${item.reference_number}`)
                        }}>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-2 mb-0">Company name:  {item.company_name}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listing reason:  {item.category}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Representative(s):  
                                        {representatives.map((rep) => {
                                            if (item.company_id === rep.company_id) {
                                                return <span>  {rep.first_name} {rep.last_name},  </span>
                                            }
                                        })}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listed by: {item.user_company} ({item.user_first_name} {item.user_last_name} )</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listing date: {new_date}</p>
                        </div>
                )
                    }
                    })
            } 
            </div>
            
        </div>
        
        
     );
}
 
export default Blacklist;